export const handleExport = async (exportApi, params) => {
    try {
        const result = await exportApi(params).unwrap();

        if (result?.file_path) {
            window.open(result.file_path, "_blank");
        } else {
            console.error("Excel link not found in the response.");
        }
    } catch (error) {
        console.error("Error while fetching Excel link:", error);
    }
};